export const formSearchString = (params) => {
    const searchParamsInstance = new URLSearchParams();
    Object.entries(params).forEach(([param, value]) => {
       if (value) {
           searchParamsInstance.set(param, value);
       }
    });
    return searchParamsInstance.toString();
}
